import { openNotesModal } from '../../../State/notesModal'

export default (id, notes = null) => (dispatch) => {
  
  dispatch(openNotesModal({ id, title: 'Notes', value: notes }))

}
